import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Catering from "../views/Catering.vue";
import Gallery from "../views/Gallery.vue";
import Faq from "../views/Faq.vue";
import Contact from "../views/Contact.vue";
import Order from "../views/Order.vue";
import Franchising from "../views/Franchising.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Loz Takos | Authentic Mexican Street Food in Coquitlam, BC",
      description: "Loz Takos is an urban taqueria serving authentic Mexican street food in Coquitlam, BC. Enjoy fresh tacos, burritos, quesadillas, and more. Catering available for events."
    }
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: {
      title: "About Us | Loz Takos - Our Story & Mission",
      description: "Learn about Loz Takos, our passion for authentic Mexican street food, and our mission to bring the best tacos and burritos to Coquitlam, BC."
    }
  },
  {
    path: "/catering",
    name: "Catering",
    component: Catering,
    meta: {
      title: "Catering Services | Loz Takos - Mexican Food for Events",
      description: "Loz Takos catering services for corporate events, parties, and special occasions. Authentic Mexican food including tacos, burritos, and more in Coquitlam, BC."
    }
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      title: "Photo Gallery | Loz Takos - See Our Delicious Mexican Food",
      description: "Browse our gallery of authentic Mexican dishes at Loz Takos. See our tacos, burritos, quesadillas, and more fresh from our kitchen in Coquitlam, BC."
    }
  },
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
    meta: {
      title: "FAQ | Loz Takos - Frequently Asked Questions",
      description: "Find answers to common questions about Loz Takos, our menu, catering services, hours, location, and more."
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      title: "Contact Us | Loz Takos - Get in Touch",
      description: "Contact Loz Takos in Coquitlam, BC. Find our location, phone number, and send us a message. We'd love to hear from you!"
    }
  },
  {
    path: "/Menu",
    name: "Menu",
    component: Order,
    meta: {
      title: "Menu | Loz Takos - Tacos, Burritos, Quesadillas & More",
      description: "Explore the Loz Takos menu featuring authentic Mexican street food: tacos, burritos, burrito bowls, quesadillas, tortas, and refreshing drinks."
    }
  },
  {
    path: "/franchising",
    name: "Franchising",
    component: Franchising,
    meta: {
      title: "Franchise Opportunities | Loz Takos - Own Your Own Taqueria",
      description: "Join the Loz Takos family! Learn about franchise opportunities and become your own jefe with our authentic Mexican street food concept."
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // When opening a new route send the user to the default location (top left)
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
});

// Update page title and meta description on route change
router.beforeEach((to, from, next) => {
  // Update title
  document.title = to.meta.title || "Loz Takos | Authentic Mexican Street Food";

  // Update meta description
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute("content", to.meta.description || "Loz Takos - Authentic Mexican street food in Coquitlam, BC.");
  }

  // Update Open Graph title and description
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogTitle) {
    ogTitle.setAttribute("content", to.meta.title || "Loz Takos | Authentic Mexican Street Food");
  }
  if (ogDescription) {
    ogDescription.setAttribute("content", to.meta.description || "Loz Takos - Authentic Mexican street food in Coquitlam, BC.");
  }

  next();
});

export default router;
